import { format } from "date-fns/format";
import { isValid } from "date-fns/isValid";
import { parse } from "date-fns/parse";
const FORM_DATE_FORMAT = 'yyyyMMdd';
function parseFormDateString(date, referenceDate = new Date()) {
    if (!date) return;
    const parsed = parse(date, FORM_DATE_FORMAT, referenceDate);
    return isValid(parsed) ? parsed : void 0;
}
function getDateRangeFromFormDates(startDate, endDate, referenceDate = new Date()) {
    const from = parseFormDateString(startDate, referenceDate);
    if (!from) return;
    const to = parseFormDateString(endDate, referenceDate);
    return to ? {
        from,
        to
    } : {
        from
    };
}
function handleSingleDateCalendarChange(setValue, watchLabel, setDefaultMonth, date) {
    const formattedDate = format(date, 'yyyyMMdd');
    setValue(watchLabel, formattedDate);
    setDefaultMonth(date);
}
function handleDateRangeCalendarChange(setValue, watchStartLabel, watchEndLabel, setDefaultMonth, dates, options = {}) {
    const setDirtyValue = (name, value)=>{
        if (options.shouldDirty) return void setValue(name, value, {
            shouldDirty: true
        });
        setValue(name, value);
    };
    if (dates?.from) {
        const startDate = format(dates.from, 'yyyyMMdd');
        setDirtyValue(watchStartLabel, startDate);
        setDefaultMonth(dates.from);
        if (options.clearEndDateOnStart) setDirtyValue(watchEndLabel, '');
    }
    if (dates?.to) {
        const endDate = format(dates.to, 'yyyyMMdd');
        setDirtyValue(watchEndLabel, endDate);
    } else if (dates?.from && !options.clearEndDateOnStart) setDirtyValue(watchEndLabel, '');
}
const isString = (value)=>'string' == typeof value;
export { getDateRangeFromFormDates, handleDateRangeCalendarChange, handleSingleDateCalendarChange, isString, parseFormDateString };
